import { render, staticRenderFns } from "./SoftwareTable.vue?vue&type=template&id=e39ca688&scoped=true&"
import script from "./SoftwareTable.vue?vue&type=script&lang=js&"
export * from "./SoftwareTable.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareTable.vue?vue&type=style&index=0&id=e39ca688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39ca688",
  null
  
)

export default component.exports